import { Dispatch, SetStateAction } from "react";
import { DeploymentData } from "./deploymentTypes";
import { OrganizationOption } from "./organizationTypes";

export interface InvoiceData {
    firstName: string;
    lastName: string;
    billingEmail: string;
    phoneNumber: string;
    company: string;
    billingAddress: string;
    city: string;
    postalCode: string;
    price?: number,
    dueDate?: string,
    errors?:{
        firstName?: string;
        lastName?: string;
        billingEmail?: string;
        phoneNumber?: string;
        company?: string;
        billingAddress?: string;
        city?: string;
        postalCode?: string;
    }
}

export const initialInvoice: InvoiceData = {
    firstName: "",
    lastName: "",
    billingEmail: "",
    phoneNumber: "",
    company: "",
    billingAddress: "",
    city: "",
    postalCode: ""
} as const;

export interface ClusterInvoiceStepProp {
    invoiceData: InvoiceData, 
    setInvoiceData: Dispatch<SetStateAction<InvoiceData>>, 
    slaCheckbox:boolean, 
    setSlaCheckbox:Dispatch<SetStateAction<boolean>>, 
    deploymentData: DeploymentData, 
    slaCheckboxError:undefined | string, 
    setSlaCheckboxError:Dispatch<SetStateAction<undefined | string>>,
    hasUsedFreeTrial: boolean;
    securityAddOns: string[],
    orderSummary: any,
    selectedPlan: any
    selectedSize: string
}

export interface ClusterDetailsStepProp {
    useCustomDomain:boolean, 
    setUseCustomDomain:Dispatch<SetStateAction<boolean>>, 
    deploymentData:DeploymentData, 
    setDeploymentData:Dispatch<SetStateAction<DeploymentData>>,
    organizationOptions: OrganizationOption[],
    hasUsedFreeTrial:boolean,
    loadingOrganizations: boolean,
    organizationError: string | null,
    securityAddOns: string[],
    setSecurityAddOns: Dispatch<SetStateAction<string[]>>
    orderSummary: any,
    selectedPlan: any
    selectedSize: string
}

export interface OrderSummaryData {
  planTitle: string;
  planFeatures: string;
  planBadgeText: string;
  planSize: string;

  securityPrice: string;
  subtotal: string;
  tax: string;
  total: string;
  totalToday: string;

  dueDateFormated: string;

  yearlyOriginalSecurityPrice:string;
  yearlyOriginalSubtotal:string;
  yearlyOriginalTotal:string;
  yearlyOriginalTotalToday:string;
}

export interface OrderSummaryProps {
  orderSummary: OrderSummaryData;
  currency: string;
  securityAddOns: string[];
  hasUsedFreeTrial: boolean;
  deploymentData: DeploymentData;
}